export default "__VITE_ASSET__acdaaf5f__"